import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

export interface IUserData {
	userId: string;
	userType?: string;
	email?: string;
	hasEmail?: boolean;
	hasActiveCreditCard?: boolean;
    canUnlockWithPersonalInformation?: boolean;
	hasSMSOtp?: boolean;
	isChangePass?: boolean;
	company?: string;
	maskedPhoneNumber?: string;
}

export class UserData implements IUserData {
	public userId: string;
	public userType?: string;
	public email?: string;
	public hasEmail?: boolean;
	public hasActiveCreditCard?: boolean;
	public canUnlockWithPersonalInformation?: boolean;
	public hasSMSOtp?: boolean;
	public isChangePass?: boolean;
	public company?: string;
	public maskedPhoneNumber?: string;

	private static _userDataSub: BehaviorSubject<IUserData> = new BehaviorSubject<IUserData>(null);
	public static readonly data$: Observable<IUserData> = UserData._userDataSub.asObservable();

	public static get isCorporate$(): Observable<boolean> {
		return UserData.data$.pipe(
			map((userData) => userData && UserData.isCorporate(userData.userType))
		);
	}

	public static isCorporate(userType: string): boolean {
		return userType === 'COMP_USER';
	}

	public static update(data: IUserData, override = false): void {
		let currentVal: IUserData;
		if (override) {
			currentVal = data;
		} else {
			currentVal = UserData._userDataSub.value || { userId: '' };
			if (data.userId) currentVal.userId = data.userId;
			if (data.userType) currentVal.userType = data.userType;
			if (data.email) currentVal.email = data.email;
			if (data.hasEmail != undefined) currentVal.hasEmail = data.hasEmail;
			if (data.hasActiveCreditCard != undefined) currentVal.hasActiveCreditCard = data.hasActiveCreditCard;
            if (data.canUnlockWithPersonalInformation != undefined) currentVal.canUnlockWithPersonalInformation = data.canUnlockWithPersonalInformation;
			if (data.hasSMSOtp != undefined) currentVal.hasSMSOtp = data.hasSMSOtp;
			if (data.isChangePass != undefined) currentVal.isChangePass = data.isChangePass;
			if (data.company) currentVal.company = data.company;
			if (data.maskedPhoneNumber) currentVal.maskedPhoneNumber = data.maskedPhoneNumber;
		}

		UserData._userDataSub.next(currentVal);
	}
}
